import api from '../../index';
import { qs } from "../../../utils/utils.js";

export const GetActiveBanner = (params) => api.get(`banner/getactivebanner?${qs(params)}`);